export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      resources: "Resources",
      cases: "Case Studies",
      contact: "Contact",
      talk: "Talk to Sinovar",
      servicesMenu: {
        source: "Source",
        pay: "Pay",
        finance: "Finance",
        move: "Move",
      },
    },
    hero: {
      tag: "China Trade Partner",
      l1: "You Grow.",
      l2: "We Handle Your",
      l3: "China Trade.",
      sub: "Source, pay, finance and ship your goods from China — all through one trusted partner.",
      primary: "Talk to Sinovar",
      secondary: "Explore Our Services",
      chip: "Indonesia business · Sinovar · China supply",
      waMsg: "Hi Sinovar, I'd like to talk about handling my China trade.",
    },
    proof: {
      items: [
        { value: "Rp90B+", label: "Trade Facilitated" },
        { value: "380+", label: "Businesses Served" },
        { value: "5,000+ CBM", label: "Goods Moved by Sea" },
        { value: "2,300+", label: "Orders Handled" },
        { value: "100+ FCL", label: "Shipments" },
      ],
    },
    services: {
      kicker: "What we do",
      title: "Everything you need from China.",
      titleA: "Everything you need",
      titleB: "from China.",
      learnMore: "Learn more",
      how: {
        title: "How it works",
        steps: [
          { n: "01", t: "Tell us what you need", d: "Share a product, a link, or a sourcing goal." },
          { n: "02", t: "We handle China", d: "Sourcing, payments, financing and logistics under one team." },
          { n: "03", t: "Goods arrive in Indonesia", d: "Delivered to your door, customs cleared." },
        ],
      },
      bullets: {
        source: ["Verified supplier discovery", "Price & option comparison", "Sample coordination", "Negotiation support"],
        pay: ["Secure RMB supplier payments", "Supplier verification", "Transparent FX handling", "Payment tracking"],
        finance: ["Flexible terms for eligible deals", "Cash-flow friendly structures", "Case-by-case assessment"],
        move: ["Sea & air freight", "Customs clearance", "Cargo consolidation", "Door-to-door delivery"],
      },
      items: [
        { key: "source", name: "SOURCE", tagline: "Find it.", desc: "We help you find reliable suppliers, compare options, and negotiate the right deal." },
        { key: "pay", name: "PAY", tagline: "Pay for it.", desc: "Handle RMB supplier payments securely and efficiently through Sinovar." },
        { key: "finance", name: "FINANCE", tagline: "Fund it.", desc: "Flexible financing solutions for eligible transactions to help keep your business moving." },
        { key: "move", name: "MOVE", tagline: "Bring it home.", desc: "From China to your door. We coordinate shipping, customs, and delivery." },
      ],
    },
    sendLink: {
      kicker: "Send us the link",
      title: "Already found it on 1688 or Alibaba?",
      highlight: "Send us the link.",
      desc: "We'll help communicate with the supplier, negotiate when possible, arrange your RMB payment, and bring the goods to Indonesia.",
      placeholder: "Paste your product link here",
      cta: "Send Link",
      note: "1688 and Alibaba are marketplaces our customers use for sourcing.",
      support: "Supports links from 1688, Alibaba, Taobao, Tmall and more.",
      privacy: "We review every link securely. Your information is kept private.",
      benefits: ["Supplier Communication", "Negotiation Support", "RMB Payment", "Delivered to Indonesia"],
      checklist: ["We check the supplier", "Negotiate the best option", "Handle payment in RMB", "Goods delivered to Indonesia"],
      popular: "Popular product sources",
      waMsg: "Hi Sinovar, here's a product link I found: ",
      empty: "Please paste a product link first.",
    },
    diff: {
      kicker: "Why Sinovar",
      title: "More than shipping goods.",
      titleAccent: "We think about your business.",
      items: [
        { name: "Better Economics", desc: "We look at the full picture — product cost, FX, freight, and your business's cash flow." },
        { name: "One Partner, Start to Finish", desc: "One partner, one team. Fewer parties for you to coordinate." },
        { name: "Support That Scales With You", desc: "From your first shipment to recurring imports, Sinovar's service grows with your business needs." },
      ],
    },
    caseStudy: {
      kicker: "Case Study",
      featured: "FEATURED CASE STUDY",
      brand: "LBS STORE × SINOVAR",
      title: "Growing from LCL to FCL — with one partner handling the China side.",
      titleA: "Growing from ",
      titleB: "LCL to FCL",
      titleC: " — with one partner handling the China side.",
      desc: "Since 2024, Sinovar has supported LBS Store across sourcing, supplier payments, shipping, and import advisory. What started with smaller LCL shipments has grown into recurring FCL shipments as the business scaled.",
      label: "Working together since 2024",
      cta: "Read the Full Story",
      serviceBar: ["Sourcing & Supplier Management", "Supplier Payments", "Logistics & Shipping", "Import Advisory", "Flexible Commercial Arrangements"],
    },
    way: {
      kicker: "The Sinovar Way",
      title: "We think beyond the shipment.",
      sub: "Because better China procurement isn't only about freight. We look at supplier cost, payment, cash flow, logistics, and what makes sense for your business.",
      cta: "Learn how Sinovar works",
      items: [
        { name: "We Start by Understanding Your Business", desc: "Before recommending anything, we understand what you buy, how you sell, and what matters to your economics." },
        { name: "We Look at the Full Economics", desc: "Supplier price, FX, freight, and cash flow all matter. We look at them together." },
        { name: "We Stay Accountable Until It's Solved", desc: "Your Sinovar team stays involved from the first question until the issue is resolved." },
        { name: "We Adapt as Your Business Grows", desc: "As your purchasing grows, we adapt how we source, pay, finance, and ship for you." },
      ],
    },
    trust: {
      title: "Make your China procurement simpler.",
      sub: "Tell us what you're buying—or send us the product link. We'll help you figure out the best way to source, pay, finance, and ship it.",
      cta: "Talk to Sinovar",
      wa: "WhatsApp",
      secondary: "Send Product Link",
    },
    footer: {
      promise: "You Grow. We Handle Your China Trade.",
      navTitle: "Company",
      servicesTitle: "Services",
      contactTitle: "Contact",
      cs1: "Customer Service 1",
      cs2: "Customer Service 2",
      rights: "All rights reserved.",
      blurb: "China Trade Partner for Indonesian Businesses.",
    },
    pages: {
      about: {
        title: "More than a forwarder.\nA partner for your business needs from China.",
        sub: "Sinovar helps Indonesian businesses source, pay for, finance, and ship goods from China.",
        body: "Sinovar started as a China–Indonesia import service. As our customers' needs grew, so did our role — from simply helping with shipping to handling sourcing, RMB payments, financing, and the import process, all under one team that stays accountable from the first step until the goods arrive.",
      },
      services: {
        title: "Everything you need from China.",
        sub: "Four pillars, one accountable partner.",
      },
      resources: {
        title: "Resources",
        sub: "Practical guides for importing from China are on the way.",
        body: "We're preparing playbooks on China sourcing, RMB payments, import financing and logistics. Check back soon or talk to us directly.",
        categories: [
          { t: "Sourcing Guides", d: "Finding and vetting reliable China suppliers." },
          { t: "Payments & FX", d: "Paying suppliers in RMB, securely and transparently." },
          { t: "Logistics & Import", d: "Shipping, customs and delivery to Indonesia." },
        ],
      },
      cases: {
        title: "Case Studies",
        sub: "How businesses grow their China operation with Sinovar.",
      },
      contact: {
        title: "Talk to Sinovar.",
        sub: "Tell us what you're importing from China and we'll take it from there.",
        cs1: "Customer Service 1",
        cs2: "Customer Service 2",
        emailLabel: "Email",
        cta: "Chat on WhatsApp",
        waMsg: "Hi Sinovar, I'd like to discuss my China trade.",
      },
    },
    common: {
      backHome: "Back to Home",
      comingSoon: "Coming soon",
    },
  },

  id: {
    nav: {
      home: "Beranda",
      about: "Tentang Kami",
      services: "Layanan",
      resources: "Sumber Daya",
      cases: "Studi Kasus",
      contact: "Kontak",
      talk: "Konsultasi dengan Sinovar",
      servicesMenu: {
        source: "Cari",
        pay: "Bayar",
        finance: "Danai",
        move: "Kirim",
      },
    },
    hero: {
      tag: "Mitra Dagang China",
      l1: "Fokus kembangkan bisnis Anda.",
      l2: "Urusan pengadaan dari China,",
      l3: "Sinovar yang tangani.",
      sub: "Dari sourcing dan pembayaran hingga financing dan pengiriman barang dari China — semua melalui satu partner yang dapat Anda andalkan.",
      primary: "Konsultasi dengan Sinovar",
      secondary: "Lihat Layanan Kami",
      chip: "Bisnis Indonesia · Sinovar · Ekosistem pemasok China",
      waMsg: "Halo Sinovar, saya ingin bicara soal urusan dagang China saya.",
    },
    proof: {
      items: [
        { value: "Rp90B+", label: "Nilai Transaksi Difasilitasi" },
        { value: "380+", label: "Bisnis Telah Dilayani" },
        { value: "5,000+ CBM", label: "Pengiriman via Laut" },
        { value: "2,300+", label: "Pesanan Ditangani" },
        { value: "100+ FCL", label: "Pengiriman Full Container" },
      ],
    },
    services: {
      kicker: "Yang kami lakukan",
      title: "Semua yang Anda butuhkan dari China.",
      titleA: "Semua yang bisnis Anda butuhkan",
      titleB: "dari China.",
      learnMore: "Selengkapnya",
      how: {
        title: "Cara kerjanya",
        steps: [
          { n: "01", t: "Ceritakan kebutuhan Anda", d: "Bagikan produk, link, atau kebutuhan sourcing Anda." },
          { n: "02", t: "Kami urus China", d: "Sourcing, pembayaran, financing, dan logistik dalam satu tim." },
          { n: "03", t: "Barang tiba di Indonesia", d: "Diantar sampai tujuan Anda, urusan bea cukai beres." },
        ],
      },
      bullets: {
        source: ["Pencarian pemasok terverifikasi", "Perbandingan harga & opsi", "Koordinasi sampel", "Dukungan negosiasi"],
        pay: ["Pembayaran RMB yang aman", "Verifikasi pemasok", "Penanganan kurs transparan", "Pelacakan pembayaran"],
        finance: ["Termin fleksibel untuk transaksi yang memenuhi syarat", "Struktur yang ramah cash flow", "Dinilai per transaksi"],
        move: ["Angkutan laut & udara", "Pengurusan bea cukai", "Konsolidasi kargo", "Pengantaran door-to-door"],
      },
      items: [
        { key: "source", name: "SOURCE", tagline: "Find it.", desc: "Kami bantu mencari supplier yang tepat, membandingkan pilihan, dan menegosiasikan penawaran yang paling masuk akal untuk bisnis Anda." },
        { key: "pay", name: "PAY", tagline: "Pay for it.", desc: "Bayar supplier dalam RMB melalui Sinovar dengan proses yang lebih sederhana dan efisien." },
        { key: "finance", name: "FINANCE", tagline: "Fund it.", desc: "Opsi financing untuk transaksi yang memenuhi kriteria, sehingga cash flow bisnis Anda tetap lebih leluasa." },
        { key: "move", name: "MOVE", tagline: "Bring it home.", desc: "Dari China hingga tujuan Anda. Kami bantu mengoordinasikan pengiriman, proses impor, hingga barang tiba." },
      ],
    },
    sendLink: {
      kicker: "Kirim linknya",
      title: "Sudah menemukannya di 1688 atau Alibaba?",
      highlight: "Kirim linknya.",
      desc: "Sudah punya link produknya? Kirim ke Sinovar. Kami bantu koordinasi dengan supplier, negosiasi bila memungkinkan, atur pembayaran RMB, hingga pengirimannya ke Indonesia.",
      placeholder: "Tempel link produk Anda di sini",
      cta: "Kirim Link",
      note: "1688 dan Alibaba adalah marketplace yang biasa digunakan pelanggan kami untuk sourcing.",
      support: "Mendukung link dari 1688, Alibaba, Taobao, Tmall, dan lainnya.",
      privacy: "Kami memeriksa setiap link dengan aman. Informasi Anda kami jaga kerahasiaannya.",
      benefits: ["Komunikasi Supplier", "Dukungan Negosiasi", "Pembayaran RMB", "Diantar ke Indonesia"],
      checklist: ["Kami cek pemasoknya", "Negosiasi opsi terbaik", "Tangani pembayaran RMB", "Barang diantar ke Indonesia"],
      popular: "Sumber produk populer",
      waMsg: "Halo Sinovar, ini tautan produk yang saya temukan: ",
      empty: "Silakan tempel tautan produk terlebih dahulu.",
    },
    diff: {
      kicker: "Kenapa Sinovar",
      title: "Lebih dari sekadar mengirim barang.",
      titleAccent: "Kami memikirkan bisnis Anda.",
      items: [
        { name: "Hitungan Bisnis Lebih Sehat", desc: "Kami melihat gambaran utuhnya — harga produk, kurs, ongkos kirim, sampai cash flow bisnis Anda." },
        { name: "Satu Partner, dari Awal sampai Akhir", desc: "Satu partner, satu tim. Lebih sedikit pihak yang perlu Anda koordinasikan." },
        { name: "Dukungan yang Mengikuti Pertumbuhan Bisnis Anda", desc: "Dari pengiriman pertama hingga kebutuhan impor rutin, layanan Sinovar ikut berkembang bersama kebutuhan bisnis Anda." },
      ],
    },
    caseStudy: {
      kicker: "Studi Kasus",
      featured: "STUDI KASUS UNGGULAN",
      brand: "LBS STORE × SINOVAR",
      title: "Dari LCL hingga FCL — dengan satu partner untuk menangani kebutuhan dari China.",
      titleA: "Dari ",
      titleB: "LCL hingga FCL",
      titleC: " — dengan satu partner untuk menangani kebutuhan dari China.",
      desc: "Sejak 2024, Sinovar mendukung LBS Store mulai dari sourcing, pembayaran supplier, pengiriman, hingga konsultasi impor. Seiring bisnisnya berkembang, pengiriman yang awalnya menggunakan LCL kini telah berkembang menjadi pengiriman FCL secara rutin.",
      label: "Bekerja bersama sejak 2024",
      cta: "Baca Cerita Lengkap",
      serviceBar: ["Sourcing & Manajemen Pemasok", "Pembayaran Pemasok", "Logistik & Pengiriman", "Konsultasi Impor", "Pengaturan Komersial Fleksibel"],
    },
    way: {
      kicker: "The Sinovar Way",
      title: "Kami melihat lebih jauh dari sekadar pengiriman.",
      sub: "Karena procurement dari China bukan hanya soal freight. Kami juga melihat harga supplier, pembayaran, cash flow, logistik, dan apa yang paling masuk akal untuk bisnis Anda.",
      cta: "Pelajari cara kerja Sinovar",
      items: [
        { name: "Kami Mulai dengan Memahami Bisnis Anda", desc: "Sebelum memberi rekomendasi, kami pahami dulu apa yang Anda beli, bagaimana bisnis Anda berjalan, dan apa yang paling penting bagi hitungannya." },
        { name: "Kami Melihat Hitungannya Secara Menyeluruh", desc: "Harga supplier, kurs, freight, dan cash flow saling berkaitan. Kami melihat semuanya sebagai satu kesatuan." },
        { name: "Kami Tetap Bertanggung Jawab Sampai Tuntas", desc: "Tim Sinovar tetap ikut menangani dari pertanyaan pertama sampai masalah benar-benar selesai." },
        { name: "Kami Menyesuaikan Seiring Bisnis Anda Tumbuh", desc: "Saat kebutuhan pembelian Anda berkembang, cara kami membantu sourcing, pembayaran, financing, dan pengiriman juga ikut menyesuaikan." },
      ],
    },
    trust: {
      title: "Buat proses pengadaan dari China jadi lebih sederhana.",
      sub: "Ceritakan barang yang Anda butuhkan atau kirim link produknya. Tim Sinovar akan membantu menentukan cara terbaik untuk sourcing, pembayaran, financing, hingga pengirimannya.",
      cta: "Konsultasi dengan Sinovar",
      wa: "WhatsApp",
      secondary: "Kirim Link Produk",
    },
    footer: {
      promise: "Fokus kembangkan bisnis Anda. Urusan pengadaan dari China, Sinovar yang tangani.",
      navTitle: "Perusahaan",
      servicesTitle: "Layanan",
      contactTitle: "Kontak",
      cs1: "Customer Service 1",
      cs2: "Customer Service 2",
      rights: "Seluruh hak cipta dilindungi.",
      blurb: "Partner trade China untuk bisnis Indonesia.",
    },
    pages: {
      about: {
        title: "Lebih dari sekadar forwarder.\nPartner untuk kebutuhan bisnis Anda dari China.",
        sub: "Sinovar membantu bisnis Indonesia melakukan sourcing, pembayaran, financing, hingga pengiriman barang dari China.",
        body: "Sinovar berawal dari layanan impor China–Indonesia. Seiring kebutuhan pelanggan berkembang, peran kami ikut berkembang—dari sekadar membantu pengiriman menjadi menangani sourcing, pembayaran RMB, financing, hingga proses impor dalam satu tim yang bertanggung jawab dari awal sampai barang tiba.",
      },
      services: {
        title: "Semua yang Anda butuhkan dari China.",
        sub: "Empat pilar, satu partner yang bisa Anda andalkan.",
      },
      resources: {
        title: "Sumber Daya",
        sub: "Panduan praktis mengimpor dari China akan segera hadir.",
        body: "Kami sedang menyiapkan panduan seputar sourcing dari China, pembayaran RMB, financing impor, dan logistik. Nantikan kehadirannya, atau langsung hubungi tim kami.",
        categories: [
          { t: "Panduan Sourcing", d: "Menemukan dan menyeleksi supplier China yang bisa dipercaya." },
          { t: "Pembayaran & Kurs", d: "Membayar supplier dalam RMB dengan aman dan transparan." },
          { t: "Logistik & Impor", d: "Pengiriman, bea cukai, dan pengantaran ke Indonesia." },
        ],
      },
      cases: {
        title: "Studi Kasus",
        sub: "Bagaimana bisnis menumbuhkan operasi China mereka bersama Sinovar.",
      },
      contact: {
        title: "Hubungi Sinovar.",
        sub: "Ceritakan apa yang Anda impor dari China, sisanya kami yang urus.",
        cs1: "Customer Service 1",
        cs2: "Customer Service 2",
        emailLabel: "Email",
        cta: "Chat via WhatsApp",
        waMsg: "Halo Sinovar, saya ingin membahas kebutuhan barang dari China.",
      },
    },
    common: {
      backHome: "Kembali ke Beranda",
      comingSoon: "Segera hadir",
    },
  },
};
